import request from '@/utils/http';

export default {
    // 查询列表
    getLists: (data) => {
        return request({
            url: `/api-otp/netTasks`,
            method: 'post',
            data
        });
    },
    smsPass: (data) => {
        return request({
            url: `/api-otp/netTask/electronics/pass`,
            method: 'post',
            data
        });
    },
    getListss: (data) => {
        return request({
            url: `/api-otp/netTask/searchByElectronics`,
            method: 'post',
            data
        });
    },
    getListes: (data) => {
        return request({
            url: `/api-otp/netTasksAll`,
            method: 'post',
            data
        });
    },
    // 查询列表数量
    getListCount: (data) => {
        return request({
            url: `/api-otp/netTasksCount`,
            method: 'post',
            data
        });
    },
    getListCountss: (data) => {
        return request({
            url: `/api-otp/netTasksCountAll`,
            method: 'post',
            data
        });
    },
    // 异常反馈
    saveError: (data) => {
        return request({
            url: '/api-otp/abnormal/feedback',
            method: 'put',
            data
        });
    },
    // 分中心派单 - 获取分中心列表
    netList: (data) => {
        return request({
            url: `/api-otp/netInfos`,
            method: 'post',
            data
        });
    },
    // 获取工程师
    getEngineers: (data) => {
        return request({
            url: `/api-otp/engineers`,
            method: 'post',
            data
        });
    },
    // 获取工程师异常报错
    getEngineersError: (data) => {
        return request({
            url: `/api-otp/orderTryCalculateException`,
            method: 'post',
            data
        });
    },
    // 派工程师保存
    saveEngineers: (params) => {
        return request({
            url: '/api-otp/delivery/engineer',
            method: 'post',
            data: params
        });
    },
    // 网点预约信息查询
    appointmentInfo: (data) => {
        return request({
            url: `/api-otp/net/appointment/listByOrderNo`,
            method: 'post',
            data
        });
    },
    // 网点预约保存
    networkAppointment: (params) => {
        return request({
            url: `/api-otp/net/converged/appointment`,
            method: 'post',
            data: params
        });
    },
    // 网点派单&改派
    networkBooking: (params) => {
        return request({
            url: `/api-otp/net/reassignment`,
            method: 'post',
            data: params
        });
    },
    // 网点签收、用户签收等8种行内弹窗查询
    netTaskItems: (params) => {
        return request({
            url: `/api-otp/netTaskItems`,
            method: 'post',
            data: params
        });
    },
    // 用户签收弹框确认2B（终端签收）
    finalSign: (params) => {
        return request({
            url: `/api-otp/finalSign`,
            method: 'post',
            data: params
        });
    },

    // 用户签收弹框确认2C
    finalSingn2C: (params) => {
        return request({
            url: `/api-otp/netTask/C/finalSingn`,
            method: 'post',
            data: params
        });
    },

    // 生成回退单
    createReturnOrder: (params) => {
        return request({
            url: `/api-otp/createReturnOrder`,
            method: 'post',
            data: params
        });
    },

    // 上传图片
    netUpload: (params) => {
        return request({
            url: `/api-otp/netImagesSave`,
            method: 'post',
            data: params
        });
    },

    // 查看图片
    orderImages: (params) => {
        return request({
            url: `/api-otp/orderImages`,
            method: 'post',
            data: params
        });
    },

    // 删除图片
    delImages: (params) => {
        return request({
            url: `/api-otp/orderImage/${params}`,
            method: 'delete'
        });
    },

    // 详情
    taskDetail: (params) => {
        return request({
            url: `/api-otp/taskDetail`,
            method: 'get',
            params
        });
    },

    // 详情table分页查询
    netTaskItemsPage: (data) => {
        return request({
            url: `/api-otp/netTaskItemsPage`,
            method: 'post',
            data
        });
    },
    // 驳回拒签
    dismissRejuct: (data) => {
        return request({
            url: `/api-otp/netTask/B/reject`,
            method: 'post',
            data
        });
    },
    // 通过拒签
    approveRejuct: (data) => {
        return request({
            url: `/api-otp/netTask/B/pass`,
            method: 'post',
            data
        });
    },
    // 取件成功
    pickupSuccess: (data) => {
        return request({
            url: `/api-otp/net/pickup/confirm`,
            method: 'post',
            data
        });
    },
    // 取件失败
    pickupFail: (data) => {
        return request({
            url: `/api-otp/net/pickup/cancel`,
            method: 'post',
            data
        });
    },
    // 网点签收弹框确认
    networkSign: (params) => {
        return request({
            url: `/api-otp/networkSign`,
            method: 'post',
            data: params
        });
    },
    // 网点入库弹框确认
    netInfoIn: (params) => {
        return request({
            url: `/api-otp/netInfoIn`,
            method: 'post',
            data: params
        });
    },
    // 网点出库弹框确认
    netInfoOut: (params) => {
        return request({
            url: `/api-otp/netInfoOut`,
            method: 'post',
            data: params
        });
    },
    // 导出
    netTaskExport: (data) => {
        return request({
            url: `/api-otp/netTaskExport`,
            method: 'post',
            data
        });
    },
    // 日志
    netOrderLogs: (data) => {
        return request({
            url: `/api-otp/netOrderLogs`,
            method: 'post',
            data
        });
    },
    // 批量处理异常
    handleError: (data) => {
        return request({
            url: `/api-otp/net/getNetWorkManager`,
            method: 'post',
            data
        });
    },
    // 打印
    print: (params) => {
        return request({
            url: `/api-otp/netTask/printf`,
            method: 'get',
            params
        });
    },
    // 计算实际里程
    getPlanMile: (data) => {
        return request({
            url: `/api-otp/net/remoteFee?orderNo=${data}`,
            method: 'post'
        });
    },
    // 获取计费日志
    applyLogs: (params) => {
        return request({
            url: `/api-otp/applyLogs`,
            method: 'get',
            params
        });
    },
    // 保存计费
    saveApply: (data) => {
        return request({
            url: `/api-otp/applyLog/batchCreateOrUpdate`,
            method: 'post',
            data
        });
    },
    // 远程计费推bms
    sendJiFeiByNet: (data) => {
        return request({
            url: `/api-otp/net/sendJiFeiByNet`,
            method: 'post',
            data
        });
    },
    // 下发
    handleSendout: (data) => {
        return request({
            url: `/api-otp/searchNet`,
            method: 'post',
            data
        });
    },
    // 网点拒收
    networkRefuseSign: (data) => {
        return request({
            url: `/api-otp/networkRefuseSign`,
            method: 'post',
            data
        });
    }
};
